import type { ConsumerViewParams } from '../types/consumer.types';

export const buildUrlParams = (params: ConsumerViewParams): string => {
  const urlParams = new URLSearchParams();

  urlParams.append('startDate', params.startDate);
  urlParams.append('endDate', params.endDate);

  if (Object.keys(params.cups).length > 0) {
    urlParams.append('filters', JSON.stringify(params.cups));
  }

  return urlParams.toString();
};
